import { FaUserTie, FaEye, FaClock } from "react-icons/fa";
import "../../Components/style/CloudQuality.css"; // Custom CSS file for styling
import img1 from "../../image/Image _ Page/Service_popup/Cloud Solution-2.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/Cloud Solution-main.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/Cloud Solution-3.jpeg";
import {
  FaCloud,
  FaServer,
  FaDatabase,
  FaCogs,
  FaChartLine,
  FaLock,
  FaTools,
  FaSitemap,
  FaCloudUploadAlt,
  FaShieldAlt,
} from "react-icons/fa";

// Blue/white icon-card data for the "solution-card" section.
const SOLUTION_CARDS = [
  {
    icon: <FaCloud size={20} />,
    title: "Cloud Storage",
    desc: "Store your data securely in the cloud with scalable and reliable cloud storage solutions tailored to meet your business needs.",
  },
  {
    icon: <FaServer size={20} />,
    title: "Cloud Servers",
    desc: "Deploy and manage virtual servers in the cloud for flexible, scalable, and cost-effective hosting of your applications and services.",
  },
  {
    icon: <FaDatabase size={20} />,
    title: "Cloud Database Management",
    desc: "Streamline your data operations with cloud-based database management, ensuring high availability, security, and reliability.",
  },
  {
    icon: <FaCogs size={20} />,
    title: "Cloud Automation",
    desc: "Automate and optimize your cloud processes with our cloud automation solutions, ensuring efficiency and consistency across operations.",
  },
  {
    icon: <FaChartLine size={20} />,
    title: "Cloud Analytics",
    desc: "Leverage cloud analytics to gain actionable insights from your data, helping you make informed decisions and drive business growth.",
  },
  {
    icon: <FaLock size={20} />,
    title: "Cloud Security",
    desc: "Protect your cloud infrastructure and data with robust cloud security solutions, including encryption, firewalls, and threat detection.",
  },
];

// Blue/white rectangle-card data for the "quality" section list.
const QUALITY_ITEMS = [
  {
    icon: <FaUserTie size={36} color="#2563EB" />,
    title: "Experienced Cloud Professionals",
    desc: "Our team of certified experts brings years of cloud deployment experience for your success.",
  },
  {
    icon: <FaTools size={36} color="#2563EB" />,
    title: "Best Practices & Tools",
    desc: "Leverage proven methodologies, tools, and frameworks to ensure seamless cloud operations.",
  },
  {
    icon: <FaShieldAlt size={36} color="#2563EB" />,
    title: "Advanced Security",
    desc: "Implement rigorous security measures, encryption, and compliance for data protection.",
  },
  {
    icon: <FaEye size={36} color="#2563EB" />,
    title: "Continuous Monitoring",
    desc: "Proactive monitoring to resolve issues quickly and keep your cloud infrastructure healthy.",
  },
  {
    icon: <FaClock size={36} color="#2563EB" />,
    title: "24/7 Support",
    desc: "Get round-the-clock support from our team to address any cloud-related queries or challenges.",
  },
  {
    icon: <FaCloudUploadAlt size={36} color="#2563EB" />,
    title: "Scalable Cloud Solutions",
    desc: "Scale your cloud infrastructure effortlessly to meet growing business demands.",
  },
];

const Cloud = () => {
  return (
    <div>
   {/**this is banner section  */}
   <div style={{ position: "relative", width: "100%", height: "60vh" }}>
          {/* Image */}
          <img
            src={img1}
            alt="Inner Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
           
           
            }}
          />
  
          {/* Centered Text */}
          <h2
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              fontSize: "3rem",
              fontWeight: "bold",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
            }}
          >
            Cloud Solution
          </h2>
        </div>

      <section className="about-services-section">
        <div className="container">
          <div className="content-wrapper">
            {/* Image Box */}
            <div className="image-box">
              <img src={img2} alt="Cloud Service" className="service-image" />
              <div className="image-overlay">
                <span className="overlay-text">Discover Cloud Services</span>
              </div>
            </div>

            {/* Text Box */}
            <div className="text-box">
              <h5 className="section-subtitle">Cloud & Storage Solutions</h5>
              <h2 className="section-title">
              Elevate Your Business with{" "}
                <br></br><span className="highlight-text">Cloud and Storage Services</span>
              </h2>
              <p className="section-description">
              Harness the power of the cloud to revolutionize your business operations. 
              </p>
              <p className="section-description">
              Our cloud and storage solutions are secure, scalable, and designed to meet your unique requirements.
              </p>
              {/* <button className="cta-button">Learn More</button> */}
            </div>
          </div>
        </div>
      </section>

      {/* ============ SOLUTION CARDS (blue/white icon-card grid, 3 per row) ============ */}
      <section style={{ padding: "60px 40px", background: "#F3F6FC" }}>
        <style>{`
          @media (max-width: 900px) {
            .orryx-cloud-solution-grid { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 560px) {
            .orryx-cloud-solution-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            className="orryx-cloud-solution-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {SOLUTION_CARDS.map((card) => (
              <div
                key={card.title}
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "26px",
                  boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: "#DCE6FB",
                    color: "#2563EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  {card.icon}
                </div>
                <h5 style={{ fontSize: "16px", fontWeight: 700, margin: 0, marginBottom: "8px", color: "#111827" }}>
                  {card.title}
                </h5>
                <p style={{ fontSize: "13.5px", color: "#6B7280", lineHeight: 1.6, margin: 0 }}>
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ QUALITY SECTION (blue/white rectangle boxes, centered) ============ */}
      <section className="quality" style={{ width: "100%" }}>
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {/* Content Section — now centered */}
          <div
            className="quality-content"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              maxWidth: "100%",
              flex: "none",
            }}
          >
            <div className="para">
              <p>
                Ensuring Exceptional Quality for Cloud Infrastructure Services
              </p>
            </div>
            <div className="quality-head">
              <h2>
                Our Commitment to Delivering Reliable and Scalable Solutions
              </h2>
            </div>

            {/* List of Features */}
            <ul className="list-item" style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", width: "100%" }}>
              {QUALITY_ITEMS.map((item) => (
                <li key={item.title} style={{ width: "100%", maxWidth: "620px" }}>
                  <div
                    className="list-box"
                    style={{
                      background: "#fff",
                      borderRadius: "14px",
                      boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                      padding: "22px 26px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "12px",
                    }}
                  >
                    <div className="list-icon">
                      {item.icon}
                    </div>
                    <div>
                      <h4 style={{ margin: 0, marginBottom: "6px", fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                        {item.title}
                      </h4>
                      <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cloud;